// extracted by mini-css-extract-plugin
export var emphas = "meta-data-module--emphas--10fe0";
export var icon = "meta-data-module--icon--b29a3";
export var label = "meta-data-module--label--e46aa";
export var metaData = "meta-data-module--metaData--ef6a8";
export var publicationDate = "meta-data-module--publicationDate--38983";
export var share = "meta-data-module--share--1f9b3";
export var shareButton = "meta-data-module--shareButton--5eac1";
export var shareLabel = "meta-data-module--shareLabel--79473";
export var socialNetwork = "meta-data-module--socialNetwork--81670";